// List of Tailwind 3 colors in 700 shade
const colors = [
    {
        id: '#334155',
        name: 'Slate',
    },
    {
        id: '#374151',
        name: 'Gray',
    },
    {
        id: '#3f3f46',
        name: 'Zinc',
    },
    {
        id: '#404040',
        name: 'Neutral',
    },
    {
        id: '#44403c',
        name: 'Stone',
    },
    {
        id: '#b91c1c',
        name: 'Red',
    },
    {
        id: '#c2410c',
        name: 'Orange',
    },
    {
        id: '#b45309',
        name: 'Amber',
    },
    {
        id: '#a16207',
        name: 'Yellow',
    },
    {
        id: '#4d7c0f',
        name: 'Lime',
    },
    {
        id: '#15803d',
        name: 'Green',
    },
    {
        id: '#047857',
        name: 'Emerald',
    },
    {
        id: '#0f766e',
        name: 'Teal',
    },
    {
        id: '#0e7490',
        name: 'Cyan',
    },
    {
        id: '#0369a1',
        name: 'Sky',
    },
    {
        id: '#1d4ed8',
        name: 'Blue',
    },
    {
        id: '#4338ca',
        name: 'Indigo',
    },
    {
        id: '#6d28d9',
        name: 'Violet',
    },
    {
        id: '#7e22ce',
        name: 'Purple',
    },
    {
        id: '#a21caf',
        name: 'Fuchsia',
    },
    {
        id: '#be185d',
        name: 'Pink',
    },
    {
        id: '#be123c',
        name: 'Rose',
    },
];

export { colors };
